import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AuthService } from "./auth/auth.service";
import { AuthGuard } from "./auth/auth.guard";
import {
  TokenInterceptor,
  tokenInterceptorProvider,
} from "./auth/token-interceptor.service";
import { NoCacheInterceptor } from "./auth/HttpInterceptor";

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    AuthService,
    AuthGuard,
    TokenInterceptor,
    tokenInterceptorProvider,
    NoCacheInterceptor
  ],
})
export class CoreModule { }
